import { render, staticRenderFns } from "./AfterbanksWidget.vue?vue&type=template&id=514c1e73&"
import script from "./AfterbanksWidget.vue?vue&type=script&lang=js&"
export * from "./AfterbanksWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports